import { useEffect, useState } from 'react';

export default function ContactHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <section className="relative w-full h-[50vh] min-h-[350px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=modern%20office%20interior%20reception%20area%20with%20warm%20wood%20and%20concrete%20elements%20minimalist%20design%20natural%20light%20large%20windows%20green%20plants%20professional%20corporate%20headquarters%20lobby%20elegant%20atmosphere&width=1400&height=700&seq=contact-header&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <div className={`transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6">
            Contacto
          </h1>
          <div className="w-16 h-px bg-white/40 mx-auto" />
        </div>
      </div>
    </section>
  );
}